import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { DownSide } from "../../assets/SvgIcons";

const OwnLanguage = () => {
  const { i18n } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState("EN"); // Default to English
  const [isActive, setIsActive] = useState(false);
  const ref = useRef(null); // Create a ref for the language selector

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setSelectedLanguage(lng === "en" ? "EN" : "UA");
    setIsActive(false); // Close the dropdown after selecting a language
  };

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsActive(false); // Close dropdown if click is outside
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="languageSelector" ref={ref}>
      <div
        className="languageSelector-value"
        onClick={() => setIsActive(!isActive)}
      >
        <h5>{selectedLanguage}</h5>
        <DownSide />
      </div>

      {isActive && (
        <ul>
          <li onClick={() => changeLanguage("en")}>English</li>
          <li onClick={() => changeLanguage("ua")}>Українська</li>
        </ul>
      )}
    </div>
  );
};

export default OwnLanguage;
